
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.758.685a.8.8 0 10.083 1.597h2.637l4.067 10.921a.798.798 0 00.75.524h11.71a.799.799 0 00.75-.516l3.193-8.25a.8.8 0 00-.748-1.082H8.028a.798.798 0 100 1.597h13.999l-2.57 6.654H8.85L4.784 1.2a.799.799 0 00-.749-.515H.841a.8.8 0 00-.083 0zm8.867 13.84a2.408 2.408 0 00-2.396 2.396 2.408 2.408 0 002.396 2.396 2.408 2.408 0 002.396-2.396 2.408 2.408 0 00-2.396-2.395zm9.582 0a2.408 2.408 0 00-2.395 2.396 2.408 2.408 0 002.395 2.396 2.408 2.408 0 002.396-2.396 2.408 2.408 0 00-2.396-2.395zm-9.582 1.598c.45 0 .799.348.799.798 0 .45-.349.799-.799.799a.787.787 0 01-.799-.799c0-.45.348-.798.799-.798zm9.582 0c.45 0 .799.348.799.798 0 .45-.348.799-.799.799a.787.787 0 01-.798-.799c0-.45.348-.798.798-.798z","fill":"currentColor"}})])
          )
        }
      }
    